import { render, staticRenderFns } from "./EventBoothTable.vue?vue&type=template&id=c6bad8f2"
import script from "./EventBoothTable.vue?vue&type=script&lang=js"
export * from "./EventBoothTable.vue?vue&type=script&lang=js"
import style0 from "./EventBoothTable.vue?vue&type=style&index=0&id=c6bad8f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports